import {Component, OnInit, OnDestroy, ViewChild, Input} from '@angular/core';
import {EnvService} from "../../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {AuthService} from "../../services/auth.service";
import {MatLegacyTableDataSource as MatTableDataSource} from "@angular/material/legacy-table";
import {MatLegacyPaginator as MatPaginator} from "@angular/material/legacy-paginator";
import {SaCabinetFilter} from "./saCabinet.filter";
import { debounceTime } from 'rxjs/operators';
import {SettingsPersistenceService} from "../../services/settings-persistence.service";

@Component({
  selector: 'micro-saCabinets',
  templateUrl: './saCabinets.component.html'
})
export class SaCabinetsComponent implements OnInit, OnDestroy  {

  @Input()
  siteId:any;

  dataSource:MatTableDataSource<any> = new MatTableDataSource<any>();
  filter:SaCabinetFilter = new SaCabinetFilter();

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  pageSettings: SettingsPersistenceService;

  constructor(public auth:AuthService,
              private env:EnvService,
              private http:HttpClient) {
  }

  ngOnInit() {
    this.pageSettings = new SettingsPersistenceService(sessionStorage, "micro.saCabinets");
    this.pageSettings
      .setFilter(this.filter)                       // page filter object
      .setPaginator(this.paginator)                 // page paginator object
      .setEmbedded(!!this.siteId)                   // if true, the service will not save settings to storage
      .init();

    this.filter.anyChange.pipe(debounceTime(500)).subscribe(change => {
      this.reload();
    });

    if (this.siteId) {
      this.filter.siteId = this.siteId;
    }
    this.reload();
  }

  ngOnDestroy() {
  }

  reload() {
    let params:HttpParams = this.filter.getParams()
        .set("page", '' + (this.paginator.pageIndex || 0))
        .set("size", '' + (this.paginator.pageSize || this.pageSettings.defaultPageSize))
      ;

    this.http.get(`${this.env.e.url}/access/saCabinets`, {params: params}).subscribe(
      data => {
        let page = data as any;
        this.dataSource.data = page.content;
        this.paginator.pageIndex = page.number;
        this.paginator.pageSize = page.size;
        this.paginator.length = page.totalElements;
      }
    );
  }
}
